import React from "react";

const RenderLoader = () => <div className="loader" />;

export default RenderLoader;
